<!-- @format -->

<div class="row">
  <div class="col-6 form-group-mimic">
    <h4>{{ "STUDENT_APPLICATIONS.DECISION" | translate }}</h4>
    @if (
      moduleContentWorkflowDecision.state === workflowDecisionState.ACCEPTED ||
      moduleContentWorkflowDecision.state === workflowDecisionState.REJECTED ||
      moduleContentWorkflowDecision.state === workflowDecisionState.CONDITIONAL
    ) {
      <p>
        {{ "STUDENT_APPLICATIONS.DECISION_STATE." + moduleContentWorkflowDecision.state | translate }}
      </p>
    } @else {
      <p>-</p>
    }
  </div>
  @if (moduleContentWorkflowDecision.resolutionRationale) {
    <div class="col-6">
      <div class="form-group-mimic">
        <h4>{{ "STUDENT_APPLICATIONS.RESOLUTION_RATIONALE" | translate }}</h4>
        <p class="text-area-static">{{ moduleContentWorkflowDecision.resolutionRationale }}</p>
      </div>
      @if (moduleContentWorkflowDecision.state === workflowDecisionState.CONDITIONAL) {
        <div class="form-group-mimic">
          <h4>{{ "SHOW_MODULE_CONTENT_APPROVAL_MODAL." + moduleContentWorkflowType + ".CONDITIONS" | translate }}</h4>
          <p class="text-area-static">{{ moduleContentWorkflowDecision.conditionalApprovalTerms }}</p>
        </div>
      }
    </div>
  }
</div>
<sis-recommendation
  [contentRecommendation]="moduleContentWorkflowDecision.contentRecommendation"
  [formalRecommendation]="moduleContentWorkflowDecision.formalRecommendation"
  [approvalRequestType]="moduleContentWorkflowType">
</sis-recommendation>
<div class="row">
  <div class="col-6 form-group-mimic">
    <h4>{{ "STUDENT_APPLICATIONS.APPROVAL_DATE" | translate }}</h4>
    <p>{{ moduleContentWorkflowDecision.approvalDate | localDateFormat }}</p>
  </div>
  @if (moduleContentWorkflowDecision.approvedBy) {
    <div class="col-6 form-group-mimic">
      <h4>{{ "STUDENT_APPLICATIONS.HANDLED_BY" | translate }}</h4>
      <p>
        <span>{{ moduleContentWorkflowDecision.approvedBy | publicPerson | async | personFullName }}</span>
        @if (moduleContentWorkflowDecision.approverTitle) {
          <span>, {{ moduleContentWorkflowDecision.approverTitle }}</span>
        }
      </p>
    </div>
  }
</div>
